/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Cabinet, ArrowForward } from '@one-thd/sui-icons';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';

const Callout = ({ headerTitle, message, onClick, isDesktop = false }) => {

  return (
    isDesktop ? (
      <div className="sui-flex sui-justify-between sui-w-full sui-pt-3 sui-bg-primary">
        <div className="sui-flex">
          <span className="sui-flex sui-pr-3 sui-self-center">
            <Cabinet color="brand" />
          </span>
          <div>
            <Typography variant="body-xs" weight="bold">
              {headerTitle}
            </Typography>
            <Typography variant="body-xs">
              {message}
            </Typography>
          </div>
        </div>
        <div>
          <span className="sui-flex sui-w-[161px]">
            <Button fullWidth variant="ghost" endIcon={ArrowForward} onClick={onClick}>
              Shop Now
            </Button>
          </span>
        </div>
      </div>
    ) : (
      <div className="sui-flex sui-flex-col sui-w-full sui-bg-primary">
        <div className="sui-w-full sui-pl-3 sui-pr-3">
          <Typography variant="h6" weight="bold">
            {headerTitle}
          </Typography>
        </div>
        <div className="sui-w-full sui-pt-2 sui-pl-3 sui-pr-3">
          <Typography variant="body-sm">
            {message}
          </Typography>
        </div>
        <div className="sui-pt-3 sui-pb-3 sui-pl-3 sui-pr-3">
          <span className="sui-flex sui-w-full">
            <Button fullWidth variant="secondary" onClick={onClick}>
              Shop Now
            </Button>
          </span>
        </div>
      </div>
    )
  );
};

Callout.propTypes = {
  headerTitle: PropTypes.node.isRequired,
  message: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired,
};

export default Callout;
